module.exports = __webpack_public_path__ + "static/img/logo_ylLive.7b74ec6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo_ylLive.png
// module id = rAga
// module chunks = 51